import React, { useEffect } from "react";
import Support from "../components/Support";
import { useParams } from "react-router-dom";

const SupportPage = () => {
  const { id } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <>
      <Support />
    </>
  );
};

export default SupportPage;
